module.exports = __webpack_public_path__ + "img/playerBg.2e8dac64.png";